export default {
    methods: {
        requiredRegularField (condition) {
            return {
                required: condition,
                not_allowed_chars: true
            };
        },
        regularField (condition) {
            return {
                required: condition,
                max: 255,
                not_allowed_chars: true
            };
        },
        regularLongText (condition, max = 1800) {
            return {
                required: condition,
                max,
                not_allowed_chars: true
            };
        },
        requiredMoney (condition) {
            return {
                required: condition,
                custom_decimal: true,
                max: Number.MAX_SAFE_INTEGER.toString().length - 1 || 15
            };
        },
        limitRegularField (condition, limit = 150) {
            return {
                required: condition,
                min: limit,
                not_allowed_chars: true
            };
        },
        limitRegularLongField (condition, min = 300, max = 4000) {
            return {
                required: condition,
                min,
                max,
                not_allowed_chars: true
            };
        },
        packsAmountRules (condition) {
            return {
                required: condition,
                numeric: true,
                max: 3
            };
        }
    }
};
